import AuthContext, { AuthContextInterface } from "./AuthContext";
import AuthContextProvider from "./AuthContextProvider";

export { AuthContextProvider };
export type { AuthContextInterface };

export default AuthContext;
